module.exports = __webpack_public_path__ + "static/media/objects_20.e0776c31.svg";